export default {"src":"/_next/static/media/enterprise.3709d69d.svg","height":19,"width":21,"blurWidth":0,"blurHeight":0};